import { Facebook, Instagram, MessageCircle } from "lucide-react";
import { SOCIALS } from "@/data/content";

const XGlyph = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.65l-5.214-6.817-5.968 6.817H1.684l7.73-8.835L1.254 2.25h6.817l4.713 6.231 5.46-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644Z" />
  </svg>
);

const ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  x: XGlyph,
  whatsapp: MessageCircle,
};

export const SocialIcons = ({ size = 16, className = "", itemClassName = "", testPrefix = "social" }) => (
  <div className={`flex items-center gap-1.5 ${className}`}>
    {SOCIALS.map((s) => {
      const Icon = ICONS[s.id];
      return (
        <a
          key={s.id}
          data-testid={`${testPrefix}-${s.id}-link`}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${s.label} — ${s.handle}`}
          title={`${s.label} · ${s.handle}`}
          className={`flex h-9 w-9 items-center justify-center border border-white/15 text-slate-300 transition-all duration-300 hover:-translate-y-0.5 hover:border-gold hover:text-gold ${itemClassName}`}
        >
          <Icon size={size} />
        </a>
      );
    })}
  </div>
);

export const SocialCards = () => (
  <div className="grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-4">
    {SOCIALS.map((s) => {
      const Icon = ICONS[s.id];
      return (
        <a
          key={s.id}
          data-testid={`contact-social-${s.id}-link`}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center gap-4 bg-white p-6 transition-colors hover:bg-navy"
        >
          <Icon size={18} className="shrink-0 text-gold" />
          <div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-400 group-hover:text-slate-300">
              {s.label}
            </div>
            <div className="text-sm font-medium text-navy group-hover:text-white">{s.handle}</div>
          </div>
        </a>
      );
    })}
  </div>
);
